import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/grid.svg";
import smsSvg from "../assets/svg/smsSvg.svg";
import resellerSvg from "../assets/svg/resellerSvg.svg";
import usersSvg from "../assets/svg/usersSvg.svg";
import airtimeSvg from "../assets/svg/airtimeSvg.svg";
import accountSvg from "../assets/svg/accountSvg.svg";
import requestSvg from "../assets/svg/requestSvg.svg";
import { fetchMenu } from "../features/menu/menuSlice";
import passwordSvg from "../assets/svg/passwordSvg.svg";
import creditSvg from "../assets/svg/creditSvg.svg";
import adminAccountSvg from "../assets/svg/adminAccountSvg.svg";
import externalSvg from "../assets/svg/externalSvg.svg";
import withdrawalSvg from "../assets/svg/withdrawalSvg.svg";
import SidebarBrand from "./SidebarBrand";

const icons = {
  gridSvg,
  smsSvg,
  resellerSvg,
  usersSvg,
  airtimeSvg,
  accountSvg,
  requestSvg,
  passwordSvg,
  creditSvg,
  adminAccountSvg,
  externalSvg,
  withdrawalSvg,
};

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export default function SideBarOpen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { menuData } = useSelector((state) => state.menu);
  const { user } = useSelector((state) => state.auth);

  const generateMenuItems = (currentMenuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }

    const mapItems = (items, isChild) =>
      items?.map((item) => {
        const iconSrc = icons[item?.mnIcons] || gridSvg;
        return getItem(
          item?.mnName.charAt(0).toUpperCase() + item?.mnName.slice(1),
          item?.mnLink,
          !isChild ? (
            <img src={iconSrc} alt={item?.mnIcons} />
          ) : (
            <span className="weiser-sidebar-child-icon" aria-hidden="true">
              <SendOutlined />
            </span>
          ),
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });

    if (!currentMenuData || currentMenuData?.length === 0) {
      return [];
    }

    return mapItems(currentMenuData);
  };

  const items = [
    ...generateMenuItems(menuData),
    {
      type: "divider",
    },
  ];

  const handleNavigation = (e) => {
    navigate(e.key);
  };

  const [openKeys, setOpenKeys] = useState([]);
  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.length ? keys[keys.length - 1] : "";
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  useEffect(() => {
    dispatch(fetchMenu());
  }, []);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
      }}
      className="weiser-sidebar-shell weiser-desktop-sidebar weiser-sidebar-open flex flex-col h-full max-w-[256px] w-full mr-5"
    >
      <SidebarBrand />
      <div className="weiser-sidebar-scroll weiser-soft-scrollbar">
        {items?.length > 0 ? (
          <Menu
            onClick={handleNavigation}
            style={{
              width: "100%",
            }}
            className="weiser-sidebar-menu"
            mode="inline"
            items={items}
            theme="light"
            inlineCollapsed={false}
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
          />
        ) : (
          <p className="px-3 py-2 text-sm text-slate-500">Loading menu...</p>
        )}
      </div>
    </div>
  );
}
